import React, {useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400,
    marginRight: "50px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function CustomizedInputBase(props) {
  const classes = useStyles();
  const [searchText, setSearchText] = useState("");

  const setSearchData = (value) => {
    setSearchText(value);
    props.searchdetails(value);
  };


  const userKeyPress = event => {
    if (event?.key === 'Enter' && event?.target?.value?.length === 17) {
      props.onEnterKeyDown(event.target.value)
    } else if(event?.key === 'Enter' && event?.target?.value?.length < 17) {
      props.setInvalidVin('Please Enter a Valid 17 Digit VIN');
      event.preventDefault();
      event.stopPropagation();
    }
  }

  return (
    <Paper component="form" className={classes.root}>
        <SearchIcon style={{ color: 'rgba(0, 0, 0, 0.54)'}} />
      <InputBase
        defaultValue={searchText}
        className={classes.input}
        placeholder="Search Vehicle By VIN"
        inputProps={{ "aria-label": "search vehicle by VIN", maxLength: 17 }}
        onChange={(evt) => {
          setSearchData(evt.target.value)
        }}
        onKeyPress={(event) => userKeyPress(event)}
      />
      
    </Paper>
  );
}
